import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=5a15bef4&scoped=true&"
import script from "./TopBar.vue?vue&type=script&lang=js&"
export * from "./TopBar.vue?vue&type=script&lang=js&"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=5a15bef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a15bef4",
  null
  
)

export default component.exports